var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegularCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 20,
    viewBox: "0 0 33 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.05 7.14286H27.225L21.616 1.07232C21.3068 0.737761 20.9146 0.467683 20.4685 0.282068C20.0224 0.0964537 19.5339 5.35757e-05 19.0389 0H8.0092C6.65981 0 5.44655 0.711161 4.94536 1.79598L2.475 7.24375C1.05394 7.5625 0 8.67009 0 10V15C0 15.3946 0.369187 15.7143 0.825 15.7143H3.3C3.3 18.0812 5.51616 20 8.25 20C10.9838 20 13.2 18.0812 13.2 15.7143H19.8C19.8 18.0812 22.0162 20 24.75 20C27.4838 20 29.7 18.0812 29.7 15.7143H32.175C32.6308 15.7143 33 15.3946 33 15V11.4286C33 9.06161 30.7838 7.14286 28.05 7.14286ZM8.25 17.8571C6.88514 17.8571 5.775 16.896 5.775 15.7143C5.775 14.5326 6.88514 13.5714 8.25 13.5714C9.61486 13.5714 10.725 14.5326 10.725 15.7143C10.725 16.896 9.61486 17.8571 8.25 17.8571ZM11.9625 7.14286H6.0292L8.0092 2.85714H11.9625V7.14286ZM14.4375 7.14286V2.85714H19.0389L22.9989 7.14286H14.4375ZM24.75 17.8571C23.3851 17.8571 22.275 16.896 22.275 15.7143C22.275 14.5326 23.3851 13.5714 24.75 13.5714C26.1149 13.5714 27.225 14.5326 27.225 15.7143C27.225 16.896 26.1149 17.8571 24.75 17.8571Z",
    fill: "#D2D2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegularCar);
export default __webpack_public_path__ + "static/media/regular-car.d172c4f018a6295f5aee410d51a39649.svg";
export { ForwardRef as ReactComponent };